"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedPromos = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./LinkedPromos.css"));
var _uiKit = require("@cian/ui-kit");
var _LinkedPromo = require("../LinkedPromo");
var _trackAdditionalPromoClick = require("../../../PromoModal/tracking/trackAdditionalPromoClick");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LinkedPromos = props => {
  const {
    promos
  } = props;
  const [collapsedId, setCollapsedId] = React.useState(null);
  const handlePromoClick = (id, type) => {
    const isSameId = collapsedId === id;
    setCollapsedId(isSameId ? null : id);
    if (!isSameId) {
      (0, _trackAdditionalPromoClick.trackAdditionalPromoClick)({
        type,
        id
      });
    }
  };
  if (!promos) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['linked-promos']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, promos.title), promos.subtitle && /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-secondary-default"
  }, promos.subtitle)), /*#__PURE__*/React.createElement("div", null, promos.promos.map(promo => /*#__PURE__*/React.createElement(_LinkedPromo.LinkedPromo, {
    key: promo.id,
    name: promo.name,
    activeDateTo: promo.activeDateTo,
    description: promo.description,
    onClick: () => handlePromoClick(promo.id, promo.type),
    collapsed: collapsedId !== promo.id
  }))));
};
exports.LinkedPromos = LinkedPromos;